<template>
  <div class="Index">
    <div class="window_bg"></div>
    <div class="haerd">
      <div class="haerd_left">
        <div class="backBtn" @click.stop.prevent="goBack">返 回</div>
        <div class="title">让我们认识一下常见的组件</div>
      </div>
    </div>

    <div class="module_box">
      <div class="module" @click.stop.prevent="goTab">
        <div class="module_text ">
          <div class="short">选项卡</div>
        </div>
        <div class="module_img">
          <div class="tab"></div>
        </div>
      </div>
      <div class="module" @click.stop.prevent="goCheckbox">
        <div class="module_text ">
          <div class="short">多选</div>
        </div>
        <div class="module_img">
          <div class="checkbox"></div>
        </div>
      </div>
      <div class="module" @click.stop.prevent="goLabel">
        <div class="module_text ">
          <div class="short">筛选标签</div>
        </div>
        <div class="module_img">
          <div class="label"></div>
        </div>
      </div>
      <div class="module" @click.stop.prevent="goSliderSwitch">
        <div class="module_text ">
          <div class="short">滑块切换</div>
        </div>
        <div class="module_img">
          <div class="sliderSwitch"></div>
        </div>
      </div>
      <div class="module" @click.stop.prevent="goRadio">
        <div class="module_text ">
          <div class="short">单选</div>
        </div>
        <div class="module_img">
          <div class="radio"></div>
        </div>
      </div>
      <div class="module" @click.stop.prevent="goInputNumber">
        <div class="module_text ">
          <div class="">数量选择器</div>
        </div>
        <div class="module_img">
          <div class="inputNumber"></div>
        </div>
      </div>
      <div class="module" @click.stop.prevent="goSlider">
        <div class="module_text ">
          <div class="short">调节滑块</div>
        </div>
        <div class="module_img">
          <div class="slider"></div>
        </div>
      </div>
      <div class="module" @click.stop.prevent="goSelect">
        <div class="module_text ">
          <div class="short">下拉选择</div>
        </div>
        <div class="module_img">
          <div class="select"></div>
        </div>
      </div>
      <div class="module" @click.stop.prevent="goSwitch">
        <div class="module_text ">
          <div class="short">开关</div>
        </div>
        <div class="module_img">
          <div class="switch"></div>
        </div>
      </div>
      <div class="module" @click.stop.prevent="goApplet">
        <div class="module_text ">
          <div class="short">小程序</div>
        </div>
        <div class="module_img">
          <div class="applet"></div>
        </div>
      </div>
      <div class="module" @click.stop.prevent="goSounds">
        <div class="module_text ">
          <div class="short">语音</div>
        </div>
        <div class="module_img">
          <div class="sounds"></div>
        </div>
      </div>
      <div class="module" @click.stop.prevent="goCode">
        <div class="module_text ">
          <div class="">数字验证码</div>
        </div>
        <div class="module_img">
          <div class="code"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'moduleIndex',
  components: {},
  data () {
    return {}
  },
  created () {},

  mounted () {},
  beforeDestroy () {},

  methods: {
    async goBack () {
      this.$router.replace({
        path: '/recognize/recognizeIndex'
      })
    },
    async goTab () {
      this.$router.push({
        path: '/recognize/module/tab/index1'
      })
    },
    async goCheckbox () {
      this.$router.push({
        path: '/recognize/module/checkbox/index1'
      })
    },
    async goLabel () {
      this.$router.push({
        path: '/recognize/module/label/index1'
      })
    },
    async goSliderSwitch () {
      this.$router.push({
        path: '/recognize/module/sliderSwitch/index1'
      })
    },
    async goRadio () {
      this.$router.push({
        path: '/recognize/module/radio/index1'
      })
    },
    async goInputNumber () {
      this.$router.push({
        path: '/recognize/module/inputNumber/index1'
      })
    },
    async goSlider () {
      this.$router.push({
        path: '/recognize/module/slider/index1'
      })
    },
    async goSelect () {
      this.$router.push({
        path: '/recognize/module/select/index1'
      })
    },
    async goSwitch () {
      this.$router.push({
        path: '/recognize/module/switch/index1'
      })
    },
    async goApplet () {
      this.$router.push({
        path: '/recognize/module/applet/index1'
      })
    },
    async goSounds () {
      this.$router.push({
        path: '/recognize/module/sounds/index1'
      })
    },
    async goCode () {
      this.$router.push({
        path: '/recognize/module/code/index1'
      })
    }
  }
}
</script>

<style scoped lang="less">
.Index {
  position: relative;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    180deg,
    rgb(95, 141, 255) 6.107%,
    rgb(144, 181, 252) 39.695%,
    rgb(217, 240, 255) 99.237%
  );
  border-radius: 0px;
  .window_bg {
    pointer-events: none; /* 使点击穿透该元素 */
    position: absolute;
    top: -50px;
    left: -50px;
    width: 630px;
    height: 684px;
    background: url(@/assets/use/useIndex/window_bg.png) no-repeat center;
    background-size: 100% 100%;
  }
}
.haerd {
  padding: 40px 30px;
  //   display: flex;
  //   align-items: flex-end;
  //   justify-content: space-between;
  .haerd_left {
    position: relative;
    z-index: 1;
    .backBtn {
      cursor: pointer;
      width: 251px;
      height: 90px;
      background: url(@/assets/use/useIndex/backBtn.png) no-repeat center;
      background-size: 100% 100%;
      font-family: Microsoft YaHei;
      font-weight: bold;
      font-size: 40px;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      text-shadow: 0px 1px 5px rgba(200, 121, 0, 0.5);
      border-radius: 96.5px;
      box-shadow: 0px 6px 12px 1px rgba(182, 118, 118, 0.27);
    }
    .title {
      text-align: center;
      margin-top: 41px;
      // margin-left: 20px;
      font-family: SourceHanSansSC-Regular-2;
      font-weight: bold;
      font-size: 45px;
      //   width: 420px;
      color: #ffffff;
      // line-height: 82px;
    }
  }
}
.module_box {
  width: 100%;
  max-height: 73vh;
  overflow-y: auto;

  .module {
    width: 92%;
    height: 125px;
    display: flex;
    margin: 0 auto;
    margin-bottom: 20px;
    .module_text {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 15px;
      font-size: 35px;
      font-weight: 500;
      font-family: "SourceHanSansSC-Regular-2";
      width: 16%;
      border-radius: 23px 0px 0px 23px;
      background: linear-gradient(
        270deg,
        rgb(217, 233, 255),
        rgb(235, 244, 255) 98.473%
      );
    }
    .short {
      width: 70%;
    }
    .module_img {
      width: 82%;
      border-radius: 0px 23px 23px 0px;
      background: rgb(247, 250, 255);
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .tab {
    width: 247px;
    height: 71px;
    background: url("@/assets/recognize/module/moduleIndex/tab.png") no-repeat
      center;
    background-size: 100% 100%;
  }
  .checkbox {
    width: 452px;
    height: 68px;
    background: url("@/assets/recognize/module/moduleIndex/checkbox.png") no-repeat
      center;
    background-size: 100% 100%;
  }
  .label {
    width: 456px;
    height: 75px;
    background: url("@/assets/recognize/module/moduleIndex/label.png") no-repeat
      center;
    background-size: 100% 100%;
  }
  .sliderSwitch {
    width: 301px;
    height: 47px;
    background: url("@/assets/recognize/module/moduleIndex/sliderSwitch.png") no-repeat
      center;
    background-size: 100% 100%;
  }
  .radio {
    width: 328px;
    height: 68px;
    background: url("@/assets/recognize/module/moduleIndex/radio.png") no-repeat
      center;
    background-size: 100% 100%;
  }
  .inputNumber {
    width: 282px;
    height: 85px;
    background: url("@/assets/recognize/module/moduleIndex/inputNumber.png") no-repeat
      center;
    background-size: 100% 100%;
  }
  .slider {
    width: 327px;
    height: 52px;
    background: url("@/assets/recognize/module/moduleIndex/slider.png") no-repeat
      center;
    background-size: 100% 100%;
  }
  .select {
    width: 338px;
    height: 81px;
    background: url("@/assets/recognize/module/moduleIndex/select.png") no-repeat
      center;
    background-size: 100% 100%;
  }
  .switch {
    width: 335px;
    height: 86px;
    background: url("@/assets/recognize/module/moduleIndex/switch.png") no-repeat
      center;
    background-size: 100% 100%;
  }
  .applet {
    width: 218px;
    height: 93px;
    background: url("@/assets/recognize/module/moduleIndex/applet.png") no-repeat
      center;
    background-size: 100% 100%;
  }
  .sounds {
    width: 337px;
    height: 95px;
    background: url("@/assets/recognize/module/moduleIndex/sounds.png") no-repeat
      center;
    background-size: 100% 100%;
  }
  .code {
    width: 290px;
    height: 76px;
    background: url("@/assets/recognize/module/moduleIndex/code.png") no-repeat
      center;
    background-size: 100% 100%;
  }
}
</style>
